import { render, staticRenderFns } from "./ZoomGallery.vue?vue&type=template&id=1c665263&"
import script from "./ZoomGallery.vue?vue&type=script&lang=js&"
export * from "./ZoomGallery.vue?vue&type=script&lang=js&"
import style0 from "./ZoomGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/melissaallen/fuzzco/pretendstore/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c665263', component.options)
    } else {
      api.reload('1c665263', component.options)
    }
    module.hot.accept("./ZoomGallery.vue?vue&type=template&id=1c665263&", function () {
      api.rerender('1c665263', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/ZoomGallery.vue"
export default component.exports